<template>
    <div id="pt200" class="pt200" v-cloak>
        <breadcrumb :decriptPage="$t('pt200.labels.title')"></breadcrumb>
        <div class="itemTitle">
            <!-- マイページ -->
            <h2>{{$t("pt200.labels.title")}}</h2>
        </div>
        <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="PT200_PART"/>

        <div class="section-inner">
            <h3 class="sectionTitle">{{$t('pt200.labels.title')}}</h3>
            <!--説明文１-->
            <div v-html="descriptionInfo['1']" class="sectionInfo"></div>
            <!--カタログコード-->
            <ul class="catalogUl" v-if="catalogCdFlg == '1'">
                <li class="catalogLi">
                    <span class="catalogSpan">
                        <span class="catalogTitle">{{$t('common.labels.catalogCdNm')}}</span>
                        <input-check class="catalogCdInp" type="text" v-model="pT200QuickOrderPartsReqModel.catalogCd" :maxlength="10"/>
                    </span>
                </li>
            </ul>
            <table class="quickOrderTable">
                <thead>
                    <tr>
                        <!-- No. -->
                        <th>{{$t("common.labels.no")}}</th>
                        <!-- 商品番号 -->
                        <th>{{$t("common.labels.productCode")}}</th>
                        <!-- 商品名 -->
                        <th>{{$t("common.labels.productName")}}</th>
                        <!-- 単価-->
                        <th v-if="ptInitData.priceShow != 1">{{$t("common.labels.unitPrice")}}</th>
                        <!-- 数量 -->
                        <th><span id="qyt_lbl">{{$t("common.labels.quantity")}}</span></th>
                        <!-- 金額 -->
                        <th v-if="ptInitData.priceShow != 1">{{kingakuStr}}<br/>{{zeikbn}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for=" (item,index) in pT200QuickOrderPartsReqModel.model" :key="index">
                        <!--行番号-->
                        <td aria-label="No"><span>{{index+1}}</span></td>
                        <!--商品番号-->
                        <td :aria-label="$t('common.labels.productCode')">
                            <input-check type="text" v-model="item.itemNo" @on-input-change="doAjax(index)" class="half" maxlength="70" :id="'itemNo_'+index" />
                        </td>
                        <!--商品名-->
                        <td :aria-label="$t('common.labels.productName')">{{item.itemNm}}</td>
                        <!--単価-->
                        <td :aria-label="$t('common.labels.unitPrice')" v-if="ptInitData.priceShow != 1">
                            <span>
                                <input-number v-model="item.saleZeiKTnk" :readonly="true"/>
                            </span>
                        </td>
                        <!--数量-->
                        <td :aria-label="$t('common.labels.quantity')">
                            <span>
                                <input-check type="text" v-model="pT200QuickOrderPartsReqModel.qyts[index]" 
                                :id="'qyt_'+index" @on-input-change ="setPrice(index)" 
                                class="num" :maxlength="5"/>
                            </span>
                        </td>
                        <!--価格-->
                        <td :aria-label="kingakuStr + zeikbn" v-if="ptInitData.priceShow != 1">
                            <span>
                                <input-number v-model="priceItem[index]" :readonly="true"/>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            
            <ul class="quickOrderBtn">
                <!-- 行を追加する -->
                <li>
                    <button class="btnSubmit" @click="addRow(rowIndex)">
                        {{$t('pt200.buttons.buttonAddRow')}}
                    </button>
                </li>
                <li>
                </li>
                <!-- ご注文手続きへ -->
                <li>
                    <button class="btnDanger" @click="doOrder">
                        <span>{{$t('pt180.buttons.orderProcedure')}}</span>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import InputCheck from "components/InputCheck";
import InputNumber from 'components/InputNumber';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /* 
    * Name of component
    */
    name: "PT200QuickOrderParts",

    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    components:{
            InputCheck,
            InputNumber,
            Message,
            Breadcrumb
        },
    data() {
        return {
            kingakuStr:null,
            zeikbn:null,
            descriptionInfo:{},
            pT200QuickOrderPartsReqModel:{
               model:[
               ],
               qyts:[],
               index:null,
               catalogCd:null
           },
            priceItem:[],
            lengthRowAdd : 10,
            rowIndex:null,
            listIdErr:[],
            listMessValid:[],
			mapMessValid:[],
            SiteConstants: SiteConstants,
            PT200_PART:'pt200',
            site: "",
            catalogCdFlg : '0',
            catalogCdRequiredFlg: '0'
        }
    },
    /*
    * 初期処理
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            var zeiKbnNm = null;
            if (_this.ptInitData.zeiKbn == "1") {
                // (税込)
                zeiKbnNm = _this.$i18n.t('common.labels.taxincluded');
            } else {
                // (税抜)
                zeiKbnNm = _this.$i18n.t('common.labels.excludingtax');
            }
            // 項目説明文
            _this.descriptionInfo = _this.ptInitData.descriptionInfo;
            // 金額
            _this.kingakuStr = _this.$i18n.t('common.labels.kingakuStr');
            _this.zeikbn = zeiKbnNm;

            // カタログコード利用オプション
            _this.catalogCdFlg = _this.ptInitData.catalogCdFlg;
            // カタログコード必須オプション
            _this.catalogCdRequiredFlg = _this.ptInitData.catalogCdRequiredFlg;
        }else{
            // eslint-disable-next-line
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT200 + _this.$UrlConstants.DO_INIT).then(function(response) {
                var zeiKbnNm = null;
                if (response.data.zeiKbn == "1") {
                    // (税込)
                    zeiKbnNm = _this.$i18n.t('common.labels.taxincluded');
                } else {
                    // (税抜)
                    zeiKbnNm = _this.$i18n.t('common.labels.excludingtax');
                }
                // 項目説明文
                _this.descriptionInfo = response.data.descriptionInfo;
                // 金額
                _this.kingakuStr = _this.$i18n.t('common.labels.kingakuStr');
                _this.zeikbn = zeiKbnNm;

                // カタログコード利用オプション
                _this.catalogCdFlg = response.data.catalogCdFlg;
                // カタログコード必須オプション
                _this.catalogCdRequiredFlg = response.data.catalogCdRequiredFlg;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }

        _this.addRow(0);
        _this.lengthRowAdd=5;
    },

    methods: {
        redirect:function(pageNo){
            var _this = this;
			common.clearMessage(_this.listIdErr,"","pt200")
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: pageNo}});
        },
        /*
        * 商品情報取得AJAX
        */
        doAjax: function(index){
            var _this = this;
            _this.pT200QuickOrderPartsReqModel.index = index;
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT200 + _this.$UrlConstants.DO_AJAX,_this.pT200QuickOrderPartsReqModel).then(function(response) {
                _this.pT200QuickOrderPartsReqModel.model = response.data.reqModel.model;
                _this.pT200QuickOrderPartsReqModel.qyts = response.data.reqModel.qyts;
                // 単価取得し数量入っていない場合 数量１をセットし数量＊単価の合計を計算
                if (_this.pT200QuickOrderPartsReqModel.model[index].saleZeiKTnk!='' && (response.data.reqModel.qyts[index] == 0 || response.data.reqModel.qyts[index] == null)){
                    _this.pT200QuickOrderPartsReqModel.qyts[index] = 1;
                    _this.priceItem[index] =_this.pT200QuickOrderPartsReqModel.qyts[index] * _this.pT200QuickOrderPartsReqModel.model[index].saleZeiKTnk;
                    _this.pT200QuickOrderPartsReqModel.model[index].saleZeiKTnk = response.data.reqModel.model[index].saleZeiKTnk;
                // 単価取得し数量入力済の場合 数量＊単価の合計を計算
                } else if (_this.pT200QuickOrderPartsReqModel.model[index].saleZeiKTnk!='' && (response.data.reqModel.qyts[index] != 0 || response.data.reqModel.qyts[index] != null)) {
                    _this.priceItem[index] =_this.pT200QuickOrderPartsReqModel.qyts[index] * _this.pT200QuickOrderPartsReqModel.model[index].saleZeiKTnk;
                    _this.pT200QuickOrderPartsReqModel.model[index].saleZeiKTnk = response.data.reqModel.model[index].saleZeiKTnk;
                // 取得できない場合は数量をセットしない
                } else {
                    _this.pT200QuickOrderPartsReqModel.qyts[index] = null;
                    _this.priceItem[index] ="";
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },

        /*
        * 金額計算
        */
        setPrice: function(index){
            var _this = this;
            var qty =  parseInt(_this.pT200QuickOrderPartsReqModel.qyts[index],10);
            var price = parseInt(_this.pT200QuickOrderPartsReqModel.model[index].saleZeiKTnk,10);
            var sumPrice = qty * price
            if(!isNaN(price) && !isNaN(sumPrice) && !isNaN(qty)){
                _this.$set(_this.priceItem, index, parseInt(sumPrice))
            }else {
                _this.$set(_this.priceItem, index, "")
            }
            
        },

        /*
        * カート追加処理
        */
        doOrder : function(){
            var _this = this;
            if (_this.catalogCdRequiredFlg == '1' && _this.pT200QuickOrderPartsReqModel.catalogCd == ''
                || _this.catalogCdRequiredFlg == '1' && _this.pT200QuickOrderPartsReqModel.catalogCd == null) {
                alert(_this.$i18n.t('common.messages.catalogRequired'));
                _this.$emit("event-loading", false);
                return;
            }
            common.clearMessageEcSite(_this.listIdErr,"pt200")
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT200 + _this.$UrlConstants.DO_ORDER,_this.pT200QuickOrderPartsReqModel).then(function(response) {
                if(response.data.status == "OK"){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}, params: {backPageNo:6}});
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.PT200_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },

        //add row 
        addRow: function (index) {
            var _this = this;
            try {
                var item = {};
                for(var i = 1 ; i <=this.lengthRowAdd ; i++  ){
                    _this.rowIndex =  _this.rowIndex + 1;
                    item = {
                        itemNo:"",
                        itemNm:"",
                        wariPrice:"",
                        saleZeiKTnk:"",
                        ecSaleTanka:""
                    };
                    _this.pT200QuickOrderPartsReqModel.model.splice(index + i, 0, item);
                }
            } catch(e)
            {
                console.log(e);
            }
        },
        
    },
    updated: function(){
        common.setFocus();
    }
}
</script>

